<template>
	<template v-if="commentText">
		<div class="tender-info__block-title">Комментарий</div>
		<div class="tender-info__block-text">
			{{ commentText }}
		</div>                    
		<div v-if="isTender" class="tender-info__block-action">
			<div class="tender-info__block-change" @click.prevent="ShowAddEditTenderCommentPopup = true">Изменить</div>
			<div class="tender-info__block-remove" @click.prevent="ShowApproveRemoveTenderComment = true">Удалить</div>
		</div>
	</template>

	<transition-group name="modal">
		<AddEditTenderCommentPopup v-if="ShowAddEditTenderCommentPopup" @close="ShowAddEditTenderCommentPopup = false" @addComment="saveComment($event)" :comment="commentText"/>
		<ApproveRemoveTenderComment v-if="ShowApproveRemoveTenderComment" @close="ShowApproveRemoveTenderComment = false" @clearComment="clearComment()" :position-id="positionId"/>
	</transition-group>
</template>

<script>
import ApproveRemoveTenderComment from "@/components/sections/Tenders/TenderInner/ApproveRemoveTenderComment.vue";
import AddEditTenderCommentPopup from "@/components/sections/Tenders/TenderInner/AddEditTenderCommentPopup.vue";
import { useToast } from "vue-toastification";
import objectToFormData from "@/utils/ObjectToFormData";
import Fetch from "@/utils/Fetch";


export default {
	name: "TenderComment",
	components: { ApproveRemoveTenderComment, AddEditTenderCommentPopup },
	props: {
		positionId: {
			type: Number,
			required: true
		},
		comment: {
			type: String,
			default: () => ''
		},
		offerCOId: {
			type: Number,
			default: () => 5
		},
		isTender: {
			type: Boolean,
			default: () => true
		}
	},

	data() {
		return {
			toast: useToast(),
			commentText: this.comment,
			ShowApproveRemoveTenderComment: false,
			ShowAddEditTenderCommentPopup: false,
			storageComment: ''
		}
	},
	methods: {
		saveComment(commentForm) {
			this.commentText = commentForm
			console.log(this.isTender, 'isTender')
			if(this.isTender) {
				this.sendForm()
			}
		},
		async sendForm() {
			if(!this.commentText) {
				return
			}
			const body = objectToFormData({
				comment: this.commentText,
				position: this.positionId,
				offer: this.offerCOId
			})

			let response = await Fetch('tenders/positions/set-comment/', {
				method: 'POST',
				body
			})

			if(response.success) {
				if(this.offerCOId) {
					this.clearComment()
				} else {
					this.toast.success('Ваш комментарий успешно добавлен');
				}

			} else {
				this.toast.error(response.message);
			}
		},
		clearComment() {
			this.commentText = ''
		},
		showAddPopup() {
			this.ShowAddEditTenderCommentPopup = true
		}
	},
 
}
</script>